const types = {
    SET_LIST_JACKPOT: '[JACKPOT] SET LIST JACKPOT',
}

export {
    types,
}